/* eslint-disable @next/next/no-img-element */
import { useS3Object } from "@/services/Amplify/hooks/getS3Object";
import { twMerge } from "tailwind-merge";

import {
  useWrapExperienceCardContext,
  type WrapExperienceCardProps,
} from "./WrapExperienceContext";

interface Props {
  onClick?: (card: WrapExperienceCardProps) => void;
  className?: string;
}

const WrapExperienceImage = ({ onClick = () => null, className }: Props) => {
  const { card } = useWrapExperienceCardContext();
  const { isError, error, data } = useS3Object({ key: card.thumbnailURL });
  if (isError) console.error(error);

  const src = data || "/images/defaultcard.png";

  const handleClick = () => {
    onClick(card);
  };
  return (
    <div
      onClick={handleClick}
      className={twMerge(
        className,
        "duration-400 relative h-full max-h-full scale-100 overflow-hidden transition-all ease-in-out group-hover:scale-110",
      )}
    >
      <img
        src={src}
        className="-z-0 h-full w-full object-fill blur-lg"
        alt=""
      />
      <img
        src={src}
        className="absolute left-1/2 top-1/2 z-10 -translate-x-1/2 -translate-y-1/2 transform"
        alt=""
      />
    </div>
  );
};

export default WrapExperienceImage;
